module.exports = __webpack_public_path__ + "static/media/mask-releve.6f056cb9.png";